import iconBlack from './scope_icon_rgb_black.svg';
import iconWhite from './scope_icon_rgb_white.svg';
import iconRegular from './scope_icon_rgb_scope_green.svg';
import logoBlack from './scope_logo_rgb_black.svg';
import logoWhite from './scope_logo_rgb_white.svg';
import logoRegular from './scope_logo_rgb_scope_green.svg';
import styles from './scope.module.css';
import { Theme, extendTheme } from '../theme-base';
import BanzaiTheme from '../banzai/banzai';

const ScopeTheme: Theme = extendTheme(BanzaiTheme, {
  id: 'scope',
  email: {
    address: 'scope@banzai.io',
    senderName: 'Banzai Scope',
  },
  primaryColor: {
    hex: '#32b4a5',
    rgb: [50, 180, 165],
    hsl: [173, 57, 45],
  },
  publicImages: {
    iconBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_icon_rgb_black.png',
    iconRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_icon_rgb_scope_green.png',
    iconWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_icon_rgb_white.png',
    logoBlack:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_logo_rgb_black.png',
    logoRegular:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_logo_rgb_scope_green.png',
    logoWhite:
      'https://banzai.nyc3.cdn.digitaloceanspaces.com/prod/email/logos/scope_logo_rgb_white.png',
  },
  iconBlack,
  iconWhite,
  iconRegular,
  iconAlt: 'Scope icon',
  logoBlack,
  logoWhite,
  logoRegular,
  logoAlt: 'Scope logo',
  styles,
  productName: 'Scope',
});

export default ScopeTheme;
